import React, { Component } from "react";

import ReactDOM from "react-dom";
import arrowIconDown from "images/ic_dropdown_arrow_down.png";
import arrowIconUp from "images/ic_dropdown_arrow_up.png";
import iconBadge from "images/ic_badge.png";
import styled from "styled-components";
import theme from "styles/theme";

const Container = styled.div`
  position: relative;
  align-self: flex-start;
  color: ${theme.colors.gray4};
`;

const OpenContainer = styled.div`
  z-index: 500;

  background: ${theme.colors.white};
  border: 2px solid transparent;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 8px;

  position: absolute;
  top: calc(-${theme.spacing.unit * 0.5}px - 2px);
  left: calc(-${theme.spacing.unit * 0.5}px - 2px);
  padding: ${theme.spacing.unit * 0.5}px ${theme.spacing.unit * 0.5}px 0;
`;

const TitleContainer = styled.div`
  cursor: pointer;
  background: ${theme.colors.white};
  min-width: 192px;
  height: 48px;
  box-sizing: border-box;
  display: flex;
  padding: ${(props) => {
    let paddingLeft = `calc(${theme.spacing.unit * 2}px - 2px)`;
    if (props.$hasMenuBadge) {
      paddingLeft = `calc(${theme.spacing.unit * 2}px + 8px - 2px)`;
    }
    return `0 calc(${theme.spacing.unit * 2}px - 2px) 0 ${paddingLeft}`;
  }};
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  border: 2px solid ${theme.colors.gray2};
`;

const Title = styled.div`
  position: relative;
  white-space: nowrap;

  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;

  ${(props) => {
    let beforeElement = null;
    if (props.$hasBadge) {
      beforeElement = `&::before {
          position: absolute;
          top: 50%;
          left: -12px;
          margin: -4px; /* half of height */
          content: "";
          display: block;
          background: url(${iconBadge}) no-repeat;
          background-size: contain;
          width: 8px;
          height: 8px;
        }`;
    } else if (props.$hasMenuBadge) {
      beforeElement = `&::before {
          position: absolute;
          top: 50%;
          left: -12px;
          margin: -4px; /* half of height */
          content: "";
          display: block;
          width: 8px;
          height: 8px;
        }`;
    }
    return beforeElement;
  }}
`;

const Arrow = styled.img`
  display: block;
  margin-left: ${theme.spacing.unit * 1}px;
`;

const Option = styled.div`
  cursor: pointer;

  height: 48px;
  display: flex;
  margin: 4px 0;
  padding: ${(props) => {
    let paddingLeft = `${theme.spacing.unit * 2}px`;
    if (props.$hasMenuBadge) {
      paddingLeft = `calc(${theme.spacing.unit * 2}px + 8px)`;
    }
    return `0 ${theme.spacing.unit * 2}px 0 ${paddingLeft}`;
  }};
  align-items: center;
  border-radius: 4px;

  :hover {
    background-color: ${theme.colors.tan};
  }
`;

const OptionLabel = styled.div`
  position: relative;

  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;

  ${(props) => {
    let beforeElement = null;
    if (props.$hasBadge) {
      beforeElement = `&::before {
        position: absolute;
        top: 50%;
        left: -12px;
        margin: -4px; /* half of height */
        content: "";
        display: block;
        background: url(${iconBadge}) no-repeat;
        background-size: contain;
        width: 8px;
        height: 8px;
      }`;
    } else if (props.$hasMenuBadge) {
      beforeElement = `&::before {
        position: absolute;
        top: 50%;
        left: -12px;
        margin: -4px; /* half of height */
        content: "";
        display: block;
        width: 8px;
        height: 8px;
      }`;
    }
    return beforeElement;
  }}
`;

export class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  componentDidMount() {
    document.addEventListener("click", this.handleOutsideClick, true);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleOutsideClick, true);
  }

  handleClick = () => {
    const { isOpen } = this.state;

    this.setState({
      isOpen: !isOpen,
    });
  };

  handleOutsideClick = (event) => {
    const domNode = ReactDOM.findDOMNode(this);

    if (!domNode || !domNode.contains(event.target)) {
      this.setState({
        isOpen: false,
      });
    }
  };

  titleContainer = (title, isArrowUp, hasMenuBadge, hasBadge) => (
    <TitleContainer onClick={this.handleClick} $hasMenuBadge={hasMenuBadge}>
      <Title $hasBadge={hasBadge} $hasMenuBadge={hasMenuBadge}>
        {title}
      </Title>
      <Arrow
        src={isArrowUp ? arrowIconUp : arrowIconDown}
        width="24"
        height="24"
        alt=""
      />
    </TitleContainer>
  );

  render() {
    const { isOpen } = this.state;
    const { className, title, options, hasBadge } = this.props;

    return (
      <Container className={className}>
        {this.titleContainer(title, false, hasBadge, hasBadge)}
        {isOpen && (
          <OpenContainer>
            {this.titleContainer(title, true, hasBadge, false)}
            {options.map((option) => (
              <Option
                key={option.label}
                onClick={option.onClick}
                $hasMenuBadge={hasBadge}
                $hasBadge={option.hasBadge}
              >
                <OptionLabel
                  $hasMenuBadge={hasBadge}
                  $hasBadge={option.hasBadge}
                >
                  {option.label}
                </OptionLabel>
              </Option>
            ))}
          </OpenContainer>
        )}
      </Container>
    );
  }
}

export default Dropdown;
